import React, { useEffect, useRef } from "react";
import SEO from "../common/SEO";
import HeaderTopBar from "../common/header/HeaderTopBar";
import HeaderOne from "../common/header/HeaderOne";
import FooterTwo from "../common/footer/FooterTwo";
import Copyright from "../common/footer/Copyright";
import Separator from "../elements/separator/Separator";

const Databank = () => {
  const revealRefs = useRef([]);

  useEffect(() => {
    const els = revealRefs.current;
    els.forEach((el) => {
      if (!el) return;
      el.style.opacity = "0";
      el.style.transform = "translateY(28px)";
      el.style.transition = "opacity 0.7s ease, transform 0.8s cubic-bezier(0.22,1,0.36,1)";
      el.style.willChange = "opacity, transform";
    });

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          const el = e.target;
          const siblings = els.filter((x) => x?.parentNode === el.parentNode);
          const index = siblings.indexOf(el);
          el.style.transitionDelay = Math.max(0, index) * 110 + "ms";
          el.style.opacity = "1";
          el.style.transform = "translateY(0)";
          io.unobserve(el);
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );

    els.forEach((el) => el && io.observe(el));

    return () => {
      io.disconnect();
    };
  }, []);

  const addToRefs = (el) => {
    if (el && !revealRefs.current.includes(el)) {
      revealRefs.current.push(el);
    }
  };

  const programs = [
    { num: "01", tag: "Connectivity", name: "Databank", desc: "Connecting communities through digital essentials mobile data and SIM cards so no one is left offline." },
    { num: "02", tag: "Essentials", name: "Multibank", desc: "Providing families with essential household goods, clothing and hygiene products with dignity, care and compassion." },
    { num: "03", tag: "Food", name: "FairShare", desc: "Reducing food waste by sharing nutritious meals and hampers, supporting healthier, stronger local communities." },
    { num: "04", tag: "Skills", name: "Digital Skills Training", desc: "Building digital confidence through practical learning technology, creativity, and pathways to careers and success." },
  ];

  const hamperItems = [
    { num: "1", name: "Fresh produce", desc: "A changing selection of vibrant fruits and crisp vegetables, sourced fresh to deliver peak flavour and nutrition." },
    { num: "2", name: "Hearty bakery items", desc: "Fresh bread and other baked goods in every hamper perfect for meals and snacks throughout the week." },
    { num: "3", name: "Everyday essentials", desc: "Pantry staples included alongside fresh produce, supporting your family's daily cooking needs." },
  ];

  const helpList = [
    "Setting up and using apps",
    "Safe online browsing",
    "Understanding online safety",
    "Getting started with social media",
    "Managing emails and more",
  ];

  const skills = [
    { num: "01", name: "Get online", desc: "Learn essential digital skills to navigate the online world confidently and safely." },
    { num: "02", name: "Build confidence", desc: "Gain practical knowledge and confidence in using technology for daily life and work." },
    { num: "03", name: "Mobile data", desc: "Access resources and connectivity to stay connected with your community and the world." },
  ];

  const galleryData = [
    [
      { img: "ethyonrow1_01.png", link: "https://www.instagram.com/p/DZKNfubgcnq/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA%3D%3D" },
      { img: "ethyonrow1_02.png", link: "https://www.instagram.com/reel/DXhQa93il12/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA%3D%3D" },
      { img: "ethyonrow1_03.png", link: "https://www.instagram.com/p/DVYnVjqk5xC/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA%3D%3D" },
      { img: "ethyonrow1_04.png", link: "https://www.instagram.com/p/DZIVNe0k5iW/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA%3D%3D" },
    ],
    [
      { img: "ethyonrow2_01.png", link: "https://www.instagram.com/reel/DQlcU2rj7Q9/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA%3D%3D" },
      { img: "ethyonrow2_02.png", link: "https://www.instagram.com/p/DW5_9TSFMKU/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA%3D%3D" },
      { img: "ethyonrow2_03.png", link: "https://www.instagram.com/reel/DWZhUMRgP11/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA%3D%3D" },
      { img: "ethyonrow2_04.png", link: "https://www.instagram.com/reel/DbDGjkSPMGq/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA%3D%3D" },
    ],
    [
      { img: "ethyonrow3_01.png", link: "https://www.instagram.com/p/DZKA04Zgb15/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA%3D%3D" },
      {
        special: true,
        items: [
          { img: "ethyonrow3_02.png", link: "https://www.instagram.com/reel/DZuRvGPFB4n/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA%3D%3D", label: "Instagram" },
          { img: "ethyonrow3-2gr_02.png", link: "https://www.google.com/maps/place/EthyOn+Cafe/@52.4800799,-1.9001004,17z/data=!3m1!5s0x4870bc8ec70ac22b:0xc22f1538a99cc821!4m8!3m7!1s0x4870bd490dca0395:0xc8a0f0b8dd1034f!8m2!3d52.4800799!4d-1.8975255!9m1!1b1!16s%2Fg%2F11lv48ml0z?entry=ttu&g_ep=EgoyMDI2MDgwMy4wIKXMDSoASAFQAw%3D%3D", label: "Google Review" },
        ],
      },
      { img: "ethyonrow3_03.png", link: "https://www.instagram.com/reel/DVa5UoSD8-K/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA%3D%3D" },
      { img: "ethyonrow3_04.png", link: "https://www.instagram.com/reel/DW_UGwXjOLy/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA%3D%3D" },
    ],
  ];

  return (
    <>
      <SEO
        title="WhatsOn Databank Communit Digital Inclusion"
        openGraph={{
          title: "WhatsOn Databank Community Digital Inclusion",
          description: "WhatsOn Databank supports lives through essential resources mobile data and SIMs, affordable digital skills training and friendly one-to-one tech training. Everyone is welcome.",
          url: "https://bd.whatson.agency/databank",
          type: "website",
        }}
      />
      <main className="databank-page-wrapper">
        <HeaderTopBar />
        <HeaderOne
          btnStyle="btn-small round btn-icon"
          HeaderSTyle="header-not-transparent"
        />
        <div className="databank-container">
          {/* Hero */}
          <header className="databank-header">
            <div className="hero-orb orb-1"></div>
            <div className="hero-orb orb-2"></div>
            <div className="hero-orb orb-3"></div>
            <div className="hero-label">
              <span className="label-dot"></span>
              <span className="label-text">A community digital inclusion programme at EthyOn Cafe, Birmingham</span>
            </div>
            <h1 ref={addToRefs} className="hero-title">
              Free data<br />Fresh ideas<br /><span className="gradient-text">Digital confidence</span>
            </h1>
            <div className="hero-content">
              <p className="hero-desc">
                WhatsOn Databank is a accessible community digital training inclusion programme that supports lives through essential resources. Everyone is welcome.
              </p>
              <div className="hero-buttons">
                <a href="#programs" className="btn btn-primary">
                  Explore programmes
                </a>
                <a href="#visit" className="btn btn-primary">
                  Find us
                </a>
              </div>
            </div>
          </header>

          {/* Marquee */}
          <div className="marquee-section">
            <div className="marquee-content">
              <span className="marquee-item">Mobile data</span><span className="marquee-sep">✦</span>
              <span className="marquee-item">Digital Skills</span><span className="marquee-sep">✦</span>
              <span className="marquee-item">IT support & training</span><span className="marquee-sep">✦</span>
              <span className="marquee-item">SIM cards</span><span className="marquee-sep">✦</span>
              <span className="marquee-item">Mobile data</span><span className="marquee-sep">✦</span>
              <span className="marquee-item">IT support & training</span><span className="marquee-sep">✦</span>
              <span className="marquee-item">SIM cards</span><span className="marquee-sep">✦</span>
              <span className="marquee-item">Digital Skills</span><span className="marquee-sep">✦</span>
            </div>
          </div>

          {/* Programmes */}
          <section id="programs" className="section section-programs">
            <div className="section-header">
              <div>
                <div className="section-subtitle">Our programmes</div>
                <h2 ref={addToRefs} className="section-title">Empowering communities, every day</h2>
              </div>
              <p className="section-text">
                Four connected programmes supporting lives through essential resources, nutritious food, digital skills, and meaningful connection.
              </p>
            </div>
            <div className="programs-grid">
              {programs.map((prog, idx) => (
                <div key={idx} ref={addToRefs} className="program-card">
                  <div className="program-header">
                    <span className="program-number">{prog.num}</span>
                    <span className="program-tag">{prog.tag}</span>
                  </div>
                  <h3 className="program-name">{prog.name}</h3>
                  <p className="program-desc">{prog.desc}</p>
                </div>
              ))}
            </div>
          </section>
              {/* Programmes end */}

              {/* EthyOn Gallery start */}
              <section id="gallery" className="section section-gallery">
                <div className="section-header">
                  <div>
                    <div className="section-subtitle">EthyOn Cafe</div>
                    <h2 ref={addToRefs} className="section-title">Moments from our community</h2>
                  </div>
                  <p className="section-text">
                    Snapshots of real sessions, food shares, training and the warm welcome waiting at EthyOn Cafe.
                  </p>
                </div>

                <div className="gallery-wrap">
                  {galleryData.map((row, rowIdx) => (
                    <div key={rowIdx} className="gallery-row">
                      {row.map((cell, cellIdx) => (
                        cell.special ? (
                          <div
                            key={`${rowIdx}-${cellIdx}`}
                            ref={addToRefs}
                            className="gallery-cell gallery-cell--split"
                          >
                            {cell.items.map((sub, subIdx) => (
                              <a
                                key={subIdx}
                                href={sub.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="gallery-link gallery-link--split"
                                aria-label={sub.label}
                              >
                                <img
                                  src={`${process.env.PUBLIC_URL}/images/databank-gallery/${sub.img}`}
                                  alt={sub.label}
                                  className="gallery-img"
                                />
                                <div className="gallery-overlay">
                                  <span className="gallery-overlay-label">{sub.label}</span>
                                  <span className="gallery-overlay-icon">↗</span>
                                </div>
                              </a>
                            ))}
                          </div>
                        ) : (
                          <div
                            key={`${rowIdx}-${cellIdx}`}
                            ref={addToRefs}
                            className="gallery-cell"
                          >
                            <a
                              href={cell.link}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="gallery-link"
                            >
                              <img
                                src={`${process.env.PUBLIC_URL}/images/databank-gallery/${cell.img}`}
                                alt={`EthyOn Cafe post ${rowIdx + 1}-${cellIdx + 1}`}
                                className="gallery-img"
                              />
                              <div className="gallery-overlay">
                                <span className="gallery-overlay-icon">↗</span>
                              </div>
                            </a>
                          </div>
                        )
                      ))}
                    </div>
                  ))}
                </div>
              </section>
              {/* EthyOn Gallery end */}


          {/* FairShare / Hampers */}
          <section id="foodshare" className="section section-hampers">
            <div className="section-inner section-inner--gaps">
              <div className="section-subtitle">FairShare Nourishing our community</div>
              <h2 ref={addToRefs} className="section-title">Community essentials, packed with the good stuff</h2>
              <div className="hampers-grid">
                <div className="hamper-items">
                  {hamperItems.map((item, idx) => (
                    <div key={idx} ref={addToRefs} className="hamper-item">
                      <div className="hamper-number">{item.num}</div>
                      <div className="hamper-content">
                        <h3 className="hamper-name">{item.name}</h3>
                        <p className="hamper-desc">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
                <div ref={addToRefs} className="pricing-card">
                  <div>
                    <div className="pricing-label">How it works</div>
                    <div className="pricing-options">
                      <div className="pricing-option">
                        <span className="price">Welcome</span>
                        <span className="price-desc">Everyone is <br />welcome here</span>
                      </div>
                      <div className="pricing-option">
                        <span className="price">Bag</span>
                        <span className="price-desc">Bring your own bag<br/>and take fresh food</span>
                      </div>
                    </div>
                  </div>
                  <div className="pricing-text">A changing mix of fresh produce, bakery items and everyday essentials reducing food waste while supporting healthier, stronger local communities.</div>
                </div>
              </div>
            </div>
          </section>

          {/* Digital Skills */}
          <section id="training" className="section section-training">
            <div className="training-grid">
              <div className="training-sticky training-sticky--gaps">
                <div className="section-subtitle">Digital skills training & mobile data</div>
                <h2 ref={addToRefs} className="section-title">Friendly guidance at your pace</h2>
                <div className="section-text-group">
                  <p className="section-text">Our Digital Cafe offers support to help you feel confident using your phone, tablet or laptop in everyday life. No pressure just friendly, practical help.</p>
                
                </div>
                <div className="help-list">
                  {helpList.map((help, idx) => (
                    <div key={idx} ref={addToRefs} className="help-item">
                      <span className="help-check">✓</span>
                      <span>{help}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="skills-grid">
                {skills.map((skill, idx) => (
                  <div key={idx} ref={addToRefs} className="skill-card">
                    <span className="skill-number">{skill.num}</span>
                    <h3 className="skill-name">{skill.name}</h3>
                    <p className="skill-desc">{skill.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Wellbeing */}
          <section className="section section-wellbeing">
            <div className="wellbeing-grid">
              <div className="wellbeing-content wellbeing-content--gaps">
                <div className="section-subtitle">Tech & mental health</div>
                <h2 ref={addToRefs} className="section-title">Balance technology with well being</h2>
                <p className="section-text">Discover resources and practices to maintain a healthy relationship with digital tools while staying connected to the people who matter.</p>
              </div>
              <div className="wellbeing-items">
                <div ref={addToRefs} className="wellbeing-item">
                  <h3 className="wellbeing-name">Digital wellness</h3>
                  <p className="wellbeing-desc">Practical strategies for mindful technology use and digital detox.</p>
                </div>
                <div ref={addToRefs} className="wellbeing-item">
                  <h3 className="wellbeing-name">Healthy habits</h3>
                  <p className="wellbeing-desc">Build sustainable routines that support both productivity and well-being.</p>
                </div>
              </div>
            </div>
          </section>

          {/* Visit / CTA */}
          <section id="visit" className="section section-cta">
            <div className="cta-orb"></div>
            <div className="section-subtitle">Everyone is welcome</div>
            <h2 ref={addToRefs} className="cta-title">Drop in at EthyOn Cafe</h2>
            <p className="cta-desc">No referral needed. SIM card, Mobile data, tech help or just a friendly cup of fair trade coffee.</p>
            <a target="_blank" href="https://www.instagram.com/ethyon_cafe/" className="btn btn-primary btn-large">
              Visit EthyOn Cafe →
            </a>
            <div className="cta-grid">
              <div ref={addToRefs} className="cta-card">
                <div className="cta-label">Location</div>
                <div className="cta-content">13a Cannon Street<br />Birmingham B2 5EN</div>
              </div>
              <div ref={addToRefs} className="cta-card">
                <div className="cta-label">Opening hours</div>
                <div className="cta-content">Mon – Fri: 8am – 5pm<br />Sat: 10am – 6pm</div>
              </div>
              <div ref={addToRefs} className="cta-card">
                <div className="cta-label">Contact</div>
                <div className="cta-content">
                  <a href="tel:+4401216551122" className="cta-link">+44 0121 655 1122</a>
                </div>
              </div>
            </div>
          </section>
        </div>

        <style>{`
          .databank-container {
            min-height: 100vh;
            overflow-x: hidden;
            font-family: var(--font-primary);
          }

          /* Dark mode (default) colors */
          .databank-container {
            --bg-main: #0B0B09;
            --bg-card: #0E0E0B;
            --bg-card-alt: #12120F;
            --text-main: #F4F2EC;
            --text-muted: #B9B6AD;
            --text-dim: #6E6C64;
            --accent: #C084FC;
            --border: rgba(244,242,236,0.12);
            --border-card: rgba(244,242,236,0.14);
            background: var(--bg-main);
            color: var(--text-main);
          }

          /* Light mode colors */
          body.light .databank-container {
            --bg-main: #ffffff;
            --bg-card: #F5F8FA;
            --bg-card-alt: #F5F8FA;
            --text-main: #181818;
            --text-muted: #65676B;
            --text-dim: #8F8F8F;
            --accent: #7C3AED;
            --border: rgba(0,0,0,0.12);
            --border-card: rgba(0,0,0,0.14);
          }

          .databank-header {
            padding: 96px 48px 72px;
            max-width: 1280px;
            margin: 0 auto;
            position: relative;
          }

          .hero-orb {
            position: absolute;
            border-radius: 50%;
            filter: blur(50px);
            pointer-events: none;
          }
          .orb-1 {
            top: -60px;
            right: -40px;
            width: 480px;
            height: 480px;
            background: radial-gradient(circle, rgba(168,85,247,0.28), transparent 70%);
            animation: wodb-float 10s ease-in-out infinite;
          }
          .orb-2 {
            bottom: 40px;
            left: -120px;
            width: 400px;
            height: 400px;
            background: radial-gradient(circle, rgba(91,140,255,0.22), transparent 70%);
            animation: wodb-drift 12s ease-in-out infinite;
          }
          .orb-3 {
            top: 160px;
            left: 45%;
            width: 300px;
            height: 300px;
            background: radial-gradient(circle, rgba(236,72,153,0.16), transparent 70%);
            animation: wodb-float 14s ease-in-out -5s infinite;
          }

          .hero-label {
            display: flex;
            align-items: center;
            gap: 12px;
            margin-bottom: 32px;
          }

          .label-dot {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: var(--accent);
            animation: wodb-pulse 2.4s ease-in-out infinite;
          }

          .label-text {
            font-family: 'Space Grotesk', sans-serif;
            font-size: 13px;
            letter-spacing: 0.18em;
            text-transform: uppercase;
            color: var(--text-muted);
          }

          .hero-title {
            font-family: 'Space Grotesk', sans-serif;
            font-weight: 700;
            font-size: clamp(52px, 7.5vw, 104px);
            line-height: 0.98;
            letter-spacing: -0.035em;
            margin: 0 0 40px;
            text-wrap: balance;
          }

          .gradient-text {
            background: linear-gradient(90deg,#5B8CFF,#A855F7,#EC4899);
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
          }

          .hero-content {
            display: grid;
            grid-template-columns: 1fr auto;
            gap: 48px;
            align-items: end;
          }

          .hero-desc {
            font-size: 19px;
            line-height: 1.6;
            color: var(--text-muted);
            max-width: 520px;
            margin: 0;
          }

          .hero-buttons {
            display: flex;
            gap: 16px;
            flex-wrap: wrap;
          }

          .btn {
            display: inline-block;
            padding: 16px 32px;
            border-radius: 999px;
            font-weight: 600;
            font-size: 16px;
            text-decoration: none;
            transition: all 0.2s;
            cursor: pointer;
          }

          .btn-primary {
            background: linear-gradient(90deg,#5B8CFF,#A855F7,#EC4899);
            color: #fff;
          }
          .btn-primary:hover { filter: brightness(1.2); }

          .btn-secondary {
            border: 1px solid var(--border);
            color: var(--text-main);
          }
          .btn-secondary:hover {
            border-color: var(--accent);
            color: var(--accent);
          }

          .btn-large { padding: 18px 40px; font-size: 17px; }
          .marquee-section {
            border-top: 1px solid var(--border);
            border-bottom: 1px solid var(--border);
            overflow: hidden;
            padding: 18px 0;
            background: var(--bg-card);
          }

          .marquee-content {
            display: flex;
            gap: 0;
            width: max-content;
            animation: wodb-marquee 28s linear infinite;
            font-family: 'Space Grotesk', sans-serif;
            font-size: 15px;
            letter-spacing: 0.16em;
            text-transform: uppercase;
            color: var(--text-muted);
            white-space: nowrap;
          }

          .marquee-item { padding: 0 28px; }
          .marquee-sep { color: var(--accent); }

          .section {
            padding: 104px 48px;
            max-width: 1280px;
            margin: 0 auto;
          }

          .section-header {
            display: flex;
            align-items: flex-end;
            justify-content: space-between;
            gap: 32px;
            margin-bottom: 56px;
            flex-wrap: wrap;
          }

          .section-subtitle {
            font-family: 'Space Grotesk', sans-serif;
            font-size: 13px;
            letter-spacing: 0.18em;
            text-transform: uppercase;
            color: var(--accent);
            margin-bottom: 16px;
          }

          .section-title {
            font-family: 'Space Grotesk', sans-serif;
            font-weight: 700;
            font-size: clamp(36px,4.5vw,56px);
            line-height: 1.05;
            letter-spacing: -0.03em;
            margin: 0;
            max-width: 640px;
            text-wrap: balance;
          }

          .section-text {
            font-size: 16px;
            line-height: 1.6;
            color: var(--text-muted);
            max-width: 360px;
            margin: 0;
          }
          
          .section-text-group {
            display: flex;
            flex-direction: column;
            gap: 12px;
          }
          
          .section-text--gap {
            /* styles for the second text block if needed */
          }

          .programs-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 20px;
          }

          .program-card {
            border: 1px solid var(--border-card);
            border-radius: 20px;
            padding: 36px;
            display: flex;
            flex-direction: column;
            gap: 20px;
            background: var(--bg-card);
            transition: border-color 0.2s;
          }
          .program-card:hover { border-color: var(--accent); }

          /* ============ EthyOn Gallery ============ */

          .section-gallery {
            padding-top: 0 !important;
          }

          .gallery-wrap {
            display: flex;
            flex-direction: column;
            gap: 16px;
          }

          .gallery-row {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 16px;
            align-items: stretch;
          }

          .gallery-cell {
            position: relative;
            aspect-ratio: 1 / 1;
            width: 100%;
            border-radius: 16px;
            overflow: hidden;
            background: #000;
            border: 1px solid var(--border-card);
            transition: transform 0.35s cubic-bezier(0.22, 1, 0.36, 1),
                        border-color 0.2s ease,
                        box-shadow 0.35s ease;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .gallery-cell:hover {
            transform: translateY(-4px);
            border-color: var(--accent);
            box-shadow: 0 24px 60px -20px rgba(168, 85, 247, 0.35);
          }

          .gallery-link {
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            inset: 0;
            text-decoration: none;
            color: inherit;
          }

          .gallery-img {
            display: block;
            max-width: 100%;
            max-height: 100%;
            width: auto;
            height: auto;
            object-fit: contain;
            transition: transform 0.5s cubic-bezier(0.22, 1, 0.36, 1);
          }

          .gallery-cell:hover .gallery-img {
            transform: scale(1.02);
          }

          .gallery-overlay {
            position: absolute;
            inset: 0;
            background: linear-gradient(180deg,
              rgba(11, 11, 9, 0) 45%,
              rgba(11, 11, 9, 0.75) 100%);
            display: flex;
            align-items: flex-end;
            justify-content: flex-end;
            padding: 14px;
            opacity: 0;
            transition: opacity 0.3s ease;
            pointer-events: none;
          }

          .gallery-cell:hover .gallery-overlay {
            opacity: 1;
          }

          .gallery-overlay-icon {
            width: 38px;
            height: 38px;
            border-radius: 50%;
            background: linear-gradient(135deg, #5B8CFF, #A855F7, #EC4899);
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            font-weight: 700;
            box-shadow: 0 8px 24px rgba(168, 85, 247, 0.45);
            transform: translateY(8px);
            transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1);
            pointer-events: auto;
          }

          .gallery-cell:hover .gallery-overlay-icon {
            transform: translateY(0);
          }

          /* Split cell (row 3 col 2: Instagram + Google Review) */
          .gallery-cell--split {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 2px;
            background: var(--border);
            padding: 0;
            border: 1px solid var(--border-card);
          }

          .gallery-link--split {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            background: #000;
            width: 100%;
            height: 100%;
          }

          .gallery-link--split .gallery-img {
            max-width: 100%;
            max-height: 100%;
            width: auto;
            height: auto;
            object-fit: contain;
          }

          .gallery-link--split .gallery-overlay {
            opacity: 1;
            background: linear-gradient(180deg,
              rgba(11, 11, 9, 0) 40%,
              rgba(11, 11, 9, 0.82) 100%);
            align-items: flex-start;
            justify-content: flex-start;
            padding: 10px;
            flex-direction: column;
            gap: 4px;
            line-height: 1.2;
            pointer-events: none;
          }

          .gallery-overlay-label {
            font-family: var(--font-primary);
            font-size: 10px;
            letter-spacing: 0.14em;
            text-transform: uppercase;
            color: #fff;
            background: rgba(192, 132, 252, 0.92);
            padding: 4px 10px;
            border-radius: 999px;
            font-weight: 600;
            backdrop-filter: blur(6px);
          }

          .gallery-link--split .gallery-overlay-icon {
            position: absolute;
            bottom: 10px;
            right: 10px;
            width: 30px;
            height: 30px;
            font-size: 13px;
            transform: none;
          }

          .gallery-link--split:hover .gallery-img {
            transform: scale(1.04);
          }

          /* Light mode overrides for gallery */
          body.light .gallery-overlay {
            background: linear-gradient(180deg,
              rgba(255, 255, 255, 0) 45%,
              rgba(20, 20, 20, 0.7) 100%);
          }

          body.light .gallery-cell,
          body.light .gallery-link--split {
            background: #111;
          }

          body.light .gallery-cell:hover {
            box-shadow: 0 24px 60px -20px rgba(124, 58, 237, 0.28);
          }

          /* ============ /Gallery ============ */

          .program-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }

          .program-number {
            font-family: 'Space Grotesk', sans-serif;
            font-size: 14px;
            color: var(--text-dim);
          }

          .program-tag {
            font-family: 'Space Grotesk', sans-serif;
            font-size: 12px;
            letter-spacing: 0.14em;
            text-transform: uppercase;
            color: var(--accent);
            border: 1px solid rgba(192,132,252,0.35);
            border-radius: 999px;
            padding: 6px 14px;
          }

          .program-name {
            font-family: 'Space Grotesk', sans-serif;
            font-weight: 600;
            font-size: 30px;
            letter-spacing: -0.02em;
            margin: 0;
          }

          .program-desc {
            font-size: 16px;
            line-height: 1.6;
            color: var(--text-muted);
            margin: 0;
          }

          .section-hampers {
            background: var(--bg-card-alt);
            border-top: 1px solid var(--border);
            border-bottom: 1px solid var(--border);
            padding: 0;
            max-width: none;
          }

          .section-inner {
            padding: 104px 48px;
            max-width: 1280px;
            margin: 0 auto;
          }

          .hampers-grid {
            display: grid;
            grid-template-columns: 1.4fr 1fr;
            gap: 20px;
            align-items: stretch;
          }

          .hamper-items {
            display: grid;
            grid-template-rows: repeat(3, 1fr);
            gap: 20px;
          }

          .hamper-item {
            display: grid;
            grid-template-columns: 56px 1fr;
            gap: 24px;
            align-items: start;
            border: 1px solid var(--border-card);
            border-radius: 20px;
            padding: 28px 32px;
            background: var(--bg-card);
          }

          .hamper-number {
            width: 56px;
            height: 56px;
            border-radius: 50%;
            border: 1px solid rgba(192,132,252,0.4);
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: 'Space Grotesk', sans-serif;
            font-weight: 600;
            font-size: 18px;
            color: var(--accent);
          }

          .hamper-content {
            display: flex;
            flex-direction: column;
            gap: 8px;
          }

          .hamper-name {
            font-family: 'Space Grotesk', sans-serif;
            font-weight: 600;
            font-size: 22px;
            letter-spacing: -0.01em;
            margin: 0;
          }

          .hamper-desc {
            font-size: 15px;
            line-height: 1.6;
            color: var(--text-muted);
            margin: 0;
          }

          .pricing-card {
            border-radius: 20px;
            background: linear-gradient(135deg,#3B5BDB 0%,#7C3AED 45%,#EC4899 100%);
            color: #FFFFFF;
            padding: 40px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            gap: 32px;
          }

          .pricing-label {
            font-family: var(--font-primary);
            font-size: 13px;
            letter-spacing: 0.16em;
            text-transform: uppercase;
            margin-bottom: 20px;
            color: rgba(255,255,255,0.95);
            font-weight: 600;
          }

          .pricing-options {
            display: flex;
            flex-direction: column;
            gap: 20px;
          }

          .pricing-option {
            display: flex;
            align-items: baseline;
            gap: 16px;
            border-bottom: 1px solid rgba(255,255,255,0.3);
            padding-bottom: 20px;
          }
          .pricing-option:last-child { border-bottom: none; padding-bottom: 0; }

          .price {
            font-family: var(--font-primary);
            font-weight: 700;
            font-size: 56px;
            letter-spacing: -0.03em;
            color: rgba(255,255,255,1);
          }

          .price-desc {
            font-family: var(--font-primary);
            font-size: 16px;
            font-weight: 600;
            line-height: 1.4;
            color: rgba(255,255,255,0.95);
          }

          .pricing-text {
            font-size: 15px;
            line-height: 1.6;
            margin: 0;
            font-weight: 600;
            color: rgba(255,255,255,0.95);
          }

          .training-grid {
            display: grid;
            grid-template-columns: 1fr 1.2fr;
            gap: 64px;
            align-items: start;
          }

          .training-sticky {
            position: sticky;
            top: 120px;
          }
          
          .training-sticky--gaps,
          .wellbeing-content--gaps,
          .section-inner--gaps {
            display: flex;
            flex-direction: column;
            gap: 16px;
          }

          .help-list {
            display: flex;
            flex-direction: column;
            gap: 12px;
          }

          .help-item {
            display: flex;
            align-items: center;
            gap: 14px;
            font-size: 16px;
            color: var(--text-main);
          }

          .help-check {
            width: 22px;
            height: 22px;
            border-radius: 50%;
            background: rgba(192,132,252,0.15);
            color: var(--accent);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            flex-shrink: 0;
          }

          .skills-grid {
            display: flex;
            flex-direction: column;
            gap: 20px;
          }

          .skill-card {
            border: 1px solid var(--border-card);
            border-radius: 20px;
            padding: 36px;
            background: var(--bg-card);
            display: flex;
            flex-direction: column;
            gap: 14px;
            transition: border-color 0.2s;
          }
          .skill-card:hover { border-color: var(--accent); }

          .skill-number {
            font-family: 'Space Grotesk', sans-serif;
            font-size: 14px;
            color: var(--text-dim);
          }

          .skill-name {
            font-family: 'Space Grotesk', sans-serif;
            font-weight: 600;
            font-size: 26px;
            letter-spacing: -0.02em;
            margin: 0;
          }

          .skill-desc {
            font-size: 16px;
            line-height: 1.6;
            color: var(--text-muted);
            margin: 0;
          }

          .section-wellbeing {
            background: var(--bg-card-alt);
            border-top: 1px solid var(--border);
            border-bottom: 1px solid var(--border);
            padding: 0;
            max-width: none;
          }

          .wellbeing-grid {
            padding: 88px 48px;
            max-width: 1280px;
            margin: 0 auto;
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 64px;
            align-items: center;
          }

          .wellbeing-items {
            display: grid;
            gap: 20px;
          }

          .wellbeing-item {
            border-left: 2px solid var(--accent);
            padding: 8px 0 8px 28px;
          }

          .wellbeing-name {
            font-family: 'Space Grotesk', sans-serif;
            font-weight: 600;
            font-size: 20px;
            margin: 0 0 6px;
          }

          .wellbeing-desc {
            font-size: 15px;
            line-height: 1.6;
            color: var(--text-muted);
            margin: 0;
          }

          .section-cta {
            padding: 112px 48px 96px;
            max-width: 1280px;
            margin: 0 auto;
            text-align: center;
            position: relative;
          }

          .cta-orb {
            position: absolute;
            top: 20px;
            left: 50%;
            margin-left: -260px;
            width: 520px;
            height: 360px;
            border-radius: 50%;
            background: radial-gradient(ellipse, rgba(124,58,237,0.22), transparent 70%);
            filter: blur(50px);
            animation: wodb-float 11s ease-in-out infinite;
            pointer-events: none;
          }

          .cta-title {
            font-family: 'Space Grotesk', sans-serif;
            font-weight: 700;
            font-size: clamp(44px,6vw,80px);
            line-height: 1;
            letter-spacing: -0.035em;
            margin: 0 auto 28px;
            max-width: 900px;
            text-wrap: balance;
          }

          .cta-desc {
            font-size: 18px;
            line-height: 1.6;
            color: var(--text-muted);
            max-width: 520px;
            margin: 0 auto 40px;
          }

          .cta-grid {
            display: grid;
            grid-template-columns: repeat(3,1fr);
            gap: 1px;
            background: var(--border);
            border: 1px solid var(--border);
            border-radius: 16px;
            overflow: hidden;
            margin-top: 72px;
            text-align: left;
          }

          .cta-card {
            background: var(--bg-card);
            padding: 28px 32px;
          }

          .cta-label {
            font-family: 'Space Grotesk', sans-serif;
            font-size: 12px;
            letter-spacing: 0.16em;
            text-transform: uppercase;
            color: var(--text-dim);
            margin-bottom: 10px;
          }

          .cta-content {
            font-size: 16px;
            line-height: 1.5;
          }

          .cta-link {
            color: var(--text-main);
            text-decoration: none;
            transition: color 0.2s;
          }
          .cta-link:hover { color: var(--accent); }

          .label-text,
          .hero-title,
          .stat-number,
          .marquee-content,
          .section-subtitle,
          .section-title,
          .program-number,
          .program-tag,
          .program-name,
          .hamper-number,
          .hamper-name,
          .pricing-label,
          .price,
          .skill-number,
          .skill-name,
          .wellbeing-name,
          .cta-title,
          .cta-label {
            font-family: var(--font-primary);
          }

          /* Animations */
          @keyframes wodb-marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }
          @keyframes wodb-pulse { 0%,100% { opacity: 1; } 50% { opacity: 0.35; } }
          @keyframes wodb-float { 0%,100% { transform: translateX(-36px); } 50% { transform: translateX(36px); } }
          @keyframes wodb-drift { 0%,100% { transform: translateX(28px) translateY(-10px); } 50% { transform: translateX(-28px) translateY(10px); } }
          
          /* Responsive styles */
          @media (max-width: 1199px) {
            .gallery-row {
              grid-template-columns: repeat(3, 1fr) !important;
            }
          }

          @media (max-width: 991px) {
            .databank-header, .section-inner, .wellbeing-grid, .section-cta, .section {
              padding-left: 24px !important;
              padding-right: 24px !important;
            }
            .hero-content {
              grid-template-columns: 1fr !important;
            }
            .section-header, .training-grid, .wellbeing-grid {
              grid-template-columns: 1fr !important;
            }
            .training-sticky {
              position: static !important;
            }
            .hampers-grid {
              grid-template-columns: 1fr !important;
            }
            .hero-stats, .programs-grid, .skills-grid, .cta-grid {
              grid-template-columns: 1fr !important;
            }
            .gallery-row {
              grid-template-columns: repeat(2, 1fr) !important;
              gap: 14px !important;
            }
            .gallery-wrap {
              gap: 14px;
            }
            .gallery-cell {
              aspect-ratio: 1 / 1;
            }
            .gallery-overlay-icon {
              width: 34px;
              height: 34px;
              font-size: 15px;
            }
          }
          
          @media (max-width: 640px) {
            .databank-header, .section-inner, .wellbeing-grid, .section-cta, .section {
              padding-left: 16px !important;
              padding-right: 16px !important;
            }
            .gallery-wrap {
              gap: 12px;
            }
            .gallery-row {
              grid-template-columns: repeat(2, 1fr) !important;
              gap: 12px !important;
            }
            .gallery-cell {
              aspect-ratio: 1 / 1;
              border-radius: 12px;
            }
            .gallery-cell--split {
              grid-template-columns: 1fr;
              grid-template-rows: 1fr 1fr;
            }
            .gallery-overlay-icon {
              width: 30px;
              height: 30px;
              font-size: 13px;
            }
            .gallery-overlay {
              padding: 10px;
            }
            .gallery-cell:hover {
              transform: translateY(-2px);
            }
          }

          @media (max-width: 420px) {
            .gallery-row {
              grid-template-columns: 1fr !important;
              gap: 14px !important;
            }
            .gallery-wrap {
              gap: 14px;
            }
            .gallery-cell {
              aspect-ratio: 4 / 5;
            }
            .gallery-cell--split {
              aspect-ratio: 1 / 1;
              grid-template-columns: 1fr 1fr;
              grid-template-rows: none;
            }
            .section-gallery .section-header {
              margin-bottom: 36px;
            }
            .gallery-overlay-label {
              font-size: 9px;
              padding: 3px 8px;
              letter-spacing: 0.1em;
            }
          }
        `}</style>
        <Separator />
        <FooterTwo />
        <Copyright />
      </main>
    </>
  );
};

export default Databank;
